import { Box, HStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);
const MotionHStack = motion(HStack);

export { MotionBox, MotionHStack };
